import { numberFormatters } from "common";
import { NumberFormatKind } from "common/types";
import { ChartSelectValueFormatKind, DisplayValueType } from "store/current-dashboard/types";
const getRatioValue = (requiredValue, totalValue) => {
    if (typeof requiredValue !== "number" || typeof totalValue !== "number") {
        return requiredValue;
    }
    return requiredValue / totalValue;
};
export const treeMapChartDataLabelFormatter = (context, displayKind, displayValueType, sum) => {
    let display = "";
    switch (true) {
        case displayKind === ChartSelectValueFormatKind.percent:
            display = numberFormatters(getRatioValue(context.y, sum), NumberFormatKind.percent, { maximumSignificantDigits: 3 });
            break;
        case displayValueType === DisplayValueType.Percent:
            display = numberFormatters(context.point?.options?.custom?.compositeMeasure?.measures?.TotalPercentage ??
                getRatioValue(context.y, sum), NumberFormatKind.percent, { maximumFractionDigits: 2 });
            break;
        case displayKind === ChartSelectValueFormatKind.value:
            display = numberFormatters(context.y, NumberFormatKind.compact);
            break;
        case displayKind === ChartSelectValueFormatKind.multiple:
            display = numberFormatters(context.y, NumberFormatKind.multiple);
            break;
        default:
            display = numberFormatters(context.y, NumberFormatKind.compact, { maximumFractionDigits: 2 });
    }
    return `${context.key}<br />${display}`;
};
